import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { getLocalizedAttrValues, getLocalizedAttrValue } from '@grandvisionhq/utils';
import { getDiscountText } from '../../helpers.js';
import { getActiveVariant } from '../utils/get-active-variant.js';
import { getVariantInfo } from '../utils/get-variant-info.js';
import { getVariantUrl } from '../utils/get-variant-url.js';
import { getVariantImages } from '../utils/get-variant-images.js';

var ref;
const getProductTypeName = (product)=>{
    var ref1;
    return (ref = (ref1 = product.productType.obj) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref !== void 0 ? ref : '';
};
const getProductColor = (variant, locale)=>{
    const frameColor = getLocalizedAttrValues(variant, 'frameColor', locale);
    const lensColor = getLocalizedAttrValue(variant, 'lensColor', locale);
    const productColor = [
        ...frameColor,
        lensColor
    ].filter(Boolean).join('-');
    return !!productColor ? productColor : null;
};
var consolidateDisplayVariants = (variants)=>{
    const facetTerms = [];
    return variants.reduce((acc, variant)=>{
        const { primaryFacetTerm  } = variant, variantImageConfig = swcHelpers.objectWithoutProperties(variant, [
            "primaryFacetTerm"
        ]);
        if (primaryFacetTerm === null) {
            return [
                ...acc,
                variantImageConfig
            ];
        }
        if (!primaryFacetTerm || facetTerms.includes(primaryFacetTerm)) {
            return acc;
        }
        facetTerms.push(primaryFacetTerm);
        return [
            ...acc,
            variantImageConfig
        ];
    }, []);
};
const getOtherVariants = (variants, locale, labels)=>{
    if (variants.length < 2) {
        return [];
    }
    const thumbnailSize = {
        width: 40,
        height: 23
    };
    const otherVariantsWithFacet = variants.map((variant)=>({
            sku: variant.sku,
            image: getVariantImages(variant, locale, thumbnailSize, false, labels)[0],
            primaryFacetTerm: getProductColor(variant, locale)
        })
    );
    const consolidatedVariants = consolidateDisplayVariants(otherVariantsWithFacet);
    if (consolidatedVariants.length === 1) {
        return [];
    }
    return consolidatedVariants;
};
function useCommerceToolsProductData(product, activeSku, formatProductUrl, additionalUrlParams) {
    const { getLabel , locale  } = useIntl();
    const productType = React.useMemo(()=>getProductTypeName(product)
    , [
        product
    ]);
    const variants = React.useMemo(()=>[
            product.masterVariant,
            ...product.variants
        ]
    , [
        product.masterVariant,
        product.variants
    ]);
    const activeVariant = React.useMemo(()=>getActiveVariant(variants, activeSku)
    , [
        variants,
        activeSku
    ]);
    const variantInfo = getVariantInfo(locale, product, activeVariant, productType);
    const variantUrl = getVariantUrl(formatProductUrl, product, activeVariant, productType, additionalUrlParams);
    const promotionLabel = getDiscountText(locale, activeVariant);
    const labels = React.useMemo(()=>({
            lens: getLabel(`products.unit.contactLens`),
            lenses: getLabel(`products.unit.contactLenses`),
            perBox: getLabel(`products.perBox`)
        })
    , [
        getLabel
    ]);
    const variantImages = React.useMemo(()=>{
        const [front, angle] = getVariantImages(activeVariant, locale, undefined, true, labels);
        return {
            front,
            angle
        };
    }, [
        activeVariant,
        locale,
        labels
    ]);
    const otherVariants = React.useMemo(()=>getOtherVariants(variants, locale, labels)
    , [
        variants,
        locale,
        labels
    ]);
    const isInsuranceReimbursable = Boolean(activeVariant.isInsuranceReimbursable);
    return {
        productType,
        variantInfo,
        variantUrl,
        promotionLabel,
        variantImages,
        otherVariants,
        isInsuranceReimbursable
    };
}

export { consolidateDisplayVariants, getOtherVariants, getProductTypeName, useCommerceToolsProductData };
//# sourceMappingURL=use-ct-product-data.js.map
